import { Box, Button, Grid, TextField, Typography } from "@mui/material";
import React from "react";
import { APP_COLORS } from "../../../utils/constants";
import EastIcon from "@mui/icons-material/East";
import api from "../../../api/axios";

const inputs = [
  { id: "firstName", label: "First Name" },
  { id: "lastName", label: "Last Name" },
  { id: "title", label: "Title" },
  { id: "email", label: "Business Email" },
  { id: "phone", label: "Phone Number" },
  { id: "company", label: "Company" },
  { id: "msg", label: "Message" },
];
const initialValues = Object.fromEntries(inputs.map(({ id }) => [id, ""]));

export default function Form() {
  const [values, setValues] = React.useState(initialValues);
  const [errors, setErrors] = React.useState([]);
  const [isHovering, setIsHovering] = React.useState(false);
  const [loading, setLoading] = React.useState(false);
  const [apiResponse, setApiResponse] = React.useState({ status: "", msg: "" });

  const onChange = (e) => {
    const { name, value } = e.target;

    setErrors(errors.filter((e) => e.field !== name));
    setValues({ ...values, [name]: value });
  };

  const onSubmit = async () => {
    const newErrors = [];

    inputs.forEach(({ id, label }) => {
      const value = values[id]?.trim();

      // Empty check
      if (!value) {
        newErrors.push({ field: id, message: `${label} is required` });
        return;
      }

      // Email validation
      if (id === "email") {
        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        if (!emailRegex.test(value)) {
          newErrors.push({ field: id, message: "Invalid email address" });
          return;
        }
      }

      // Phone validation (digits only, min length 8, max length 15 for example)
      if (id === "phone") {
        const phoneRegex = /^\+?[0-9]{8,15}$/;
        if (!phoneRegex.test(value)) {
          newErrors.push({ field: id, message: "Invalid phone number" });
          return;
        }
      }
    });

    setErrors(newErrors);

    ////////////// SEND API
    if (newErrors.length === 0) {
      try {
        setLoading(true);
        const res = await api.post("/contact", values);

        console.log("Success:", res.data);
        setApiResponse({
          status: "success",
          msg: "Your Message was sent Successfully.",
        });
        setValues(initialValues);
      } catch (err) {
        console.error("API Error:", err);
        setApiResponse({
          status: "error",
          msg: "Something went wrong, please try one more time !",
        });
      } finally {
        setLoading(false);
      }
    }
  };

  return (
    <Box>
      <Grid container>
        {inputs.map((input) => {
          const { id, label } = input;
          return (
            <Grid
              size={{ xs: 12, lg: id === "msg" ? 12 : 6 }}
              sx={{
                px: 2,
                py: 4,
              }}
              key={id}
            >
              <Typography
                sx={{
                  textAlign: "left",
                  fontSize: "1.2rem",
                  opacity: 0.9,
                  fontWeight: 400,
                }}
              >
                {label.toUpperCase()}
                <span
                  style={{
                    color: errors.some((error) => error.field === id) && "red",
                  }}
                >
                  *
                </span>
              </Typography>
              <TextField
                name={id}
                value={values[id]}
                onChange={onChange}
                autoComplete="off"
                multiline={id === "msg"}
                maxRows={id === "msg" && 4}
                sx={{
                  "& input, textarea": {
                    color: APP_COLORS.BACKGROUND,
                    py: { xs: 1, lg: 2.1 },
                    fontSize: "1.1rem",
                    px: 2,
                  },

                  "& .MuiInput-underline:before": {
                    borderBottomColor: errors.some(
                      (error) => error.field === id
                    )
                      ? "red"
                      : APP_COLORS.BACKGROUND, // Default border color
                  },
                  "& .MuiInput-underline:hover:not(.Mui-disabled):before": {
                    borderBottomColor: APP_COLORS.BACKGROUND, // Hover border color
                  },
                  "& .MuiInput-underline:after": {
                    borderBottomColor: APP_COLORS.BACKGROUND, // Focused border color
                  },
                }}
                variant="standard"
                fullWidth
              />
              <Typography sx={{ color: "red", opacity: 0.6, pt: 0.5 }}>
                {errors.find((err) => err.field === id)?.message || ""}
              </Typography>
            </Grid>
          );
        })}
      </Grid>
      <Box sx={{ textAlign: "right", mr: 2 }}>
        <Button
          onClick={onSubmit}
          variant={isHovering ? "contained" : "outlined"}
          onMouseEnter={() => setIsHovering(true)}
          onMouseLeave={() => setIsHovering(false)}
          color="white"
          endIcon={<EastIcon sx={{ ml: ".7rem" }} />}
          sx={{
            backgroundColor: isHovering && APP_COLORS.BACKGROUND,
            color: isHovering && APP_COLORS.FONT,
            p: 1.5,
            mt: 3.3,
            px: "1.5rem",
            opacity: loading && 0.5,
            borderRadius: "3rem",
            border: "1px solid white",
            "&:hover": {
              border: "1px solid transparent",
            },
            transition: "all .3s ease-out",
          }}
        >
          {loading
            ? "Sending..."
            : isHovering
            ? "Schedule a meeting  "
            : "Send Message  "}
        </Button>
      </Box>
      {/* <Typography
        sx={{
          textAlign: "center",
          color: apiResponse.status === "error" ? "red" : "white",
          py: 2,
        }}
      >
        {apiResponse.msg}
      </Typography> */}
    </Box>
  );
}
